export const ReviewEditData = {
  RETIRED_BROKER_AGENT_EMERITUS: [
    {
      labelId: "pInfoReview",
      labelText: "Personal Information",
      btnId: "pInfoEdit",
    },
    {
      labelId: "resHistoryReview",
      labelText: "Residential Address",
      btnId: "resAddrEdit",
    },
    {
      labelId: "bInfoReview",
      labelText: "Business Information",
      btnId: "bInfoEdit",
    },
    {
      labelId: "eduReview",
      labelText: "Education",
      btnId: "eduEdit",
    },
    {
      labelId: "DesgReview",
      labelText: "Professional Registrations or Designations",
      btnId: "desgEdit",
    },
    {
      labelId: "ddReview",
      labelText: "Direct Deposit Information",
      btnId: "ddEdit",
    },
    {
      labelId: "mmlisReview",
      labelText: "MMLIS",
      btnId: "mmlisEdit",
    },
  ],
  CAREER_AGENT_SAMPLING: [
    {
      labelId: "pInfoReview",
      labelText: "Personal Information",
      btnId: "pInfoEdit",
    },
    {
      labelId: "resHistoryReview",
      labelText: "Residential History",
      btnId: "resHistEdit",
    },
    {
      labelId: "bInfoReview",
      labelText: "Business Information",
      btnId: "bInfoEdit",
    },
    {
      labelId: "eduReview",
      labelText: "Education",
      btnId: "eduEdit",
    },
    {
      labelId: "DesgReview",
      labelText: "Professional Registrations or Designations",
      btnId: "desgEdit",
    },
    {
      labelId: "empHistReview",
      labelText: "Employment History",
      btnId: "empHistEdit",
    },
    {
      labelId: "psrReview",
      labelText: "Personal Sales Record",
      btnId: "psrEdit",
    },
    {
      labelId: "criminalReview",
      labelText: "Criminal Disclosure",
      btnId: "criminalEdit",
    },
    {
      labelId: "regReview",
      labelText: "Regulatory Action Disclosure",
      btnId: "regEdit",
    },
    {
      labelId: "civReview",
      labelText: "Civil Judicial Disclosure",
      btnId: "civEdit",
    },
    {
      labelId: "customerReview",
      labelText: "Customer Complaint Disclosure",
      btnId: "customerEdit",
    },
    {
      labelId: "termReview",
      labelText: "Termination Disclosure",
      btnId: "termEdit",
    },
    {
      labelId: "financeReview",
      labelText: "Financial Disclosure",
      btnId: "financeEdit",
    },
    {
      labelId: "ddReview",
      labelText: "Direct Deposit Information",
      btnId: "ddEdit",
    },
    {
      labelId: "mmlisReview",
      labelText: "MMLIS",
      btnId: "mmlisEdit",
    },
  ],
  BROKER_MEMBER_CORP: [
    {
      labelId: "corpInfoReview",
      labelText: "Corporation Information",
      btnId: "corpInfoEdit",
    },
    {
      labelId: "corpBInfoReview",
      labelText: "Business Information",
      btnId: "CorpBInfoEdit",
    },
    {
      labelId: "corpCCBInfoReview",
      labelText: "Corporation Character, Credit, and Bonding",
      btnId: "corpCCBInfoEdit",
    },
    {
      labelId: "corpEOInfoReview",
      labelText:
        "Corporation Errors & Omissions (E&O) Coverage, Group Insurance",
      btnId: "corpEOInfoEdit",
    },
    {
      labelId: "corpDDReview",
      labelText: "Direct Deposit Information",
      btnId: "corpDDEdit",
    },
    {
      labelId: "pInfoReview",
      labelText: "Personal Information",
      btnId: "pInfoEdit",
    },
    {
      labelId: "resAddrReview",
      labelText: "Residential Address",
      btnId: "resAddrEdit",
    },
    {
      labelId: "bInfoReview",
      labelText: "Business Information",
      btnId: "bInfoEdit",
    },
    {
      labelId: "brokeDealReview",
      labelText: "Broker Dealer Information",
      btnId: "brokeDealEdit",
    },
    {
      labelId: "ccbReview",
      labelText: "Character, Credit, and Bonding",
      btnId: "ccbEdit",
    },
    {
      labelId: "eoReview",
      labelText: "Errors & Omissions (E&O) Coverage, Group Insurance",
      btnId: "eoEdit",
    },
  ],
  CRIA_ONLY: [
    {
      labelId: "pInfoReview",
      labelText: "Personal Information",
      btnId: "pInfoEdit",
    },
    {
      labelId: "eduReview",
      labelText: "Education",
      btnId: "eduEdit",
    },
    {
      labelId: "DesgReview",
      labelText: "Professional Registrations or Designations",
      btnId: "desgEdit",
    },
  ],
};
